const postalCodes: number[] = [
  5571,
  5080,
  5543,
  3581,
  3583,
  3590,
  3640,
  3717,
  3891,
  3980,
  8553,
  6870,
  7504,
  7822,
  1401,
  1460,
  2640,
  2382,
  2310,
  2547,
  2845,
  2060,
  2627,
  2381,
  2150,
  2387,
  3472,
  3272,
  3212,
  1640,
  3450,
  1540,
  9473,
  9112,
  9031,
  9308,
  4730,
  4632,
  4351,
  4480,
  4910,
  7510,
  7020,
  6534,
  7860,
  7330,
  7864,
  7100,
  6531,
  3722,
  8550,
  8691,
  8700,
  8760,
  6840,
  6983,
  6987,
  3120,
  1541,
  3270,
  5351,
  5540,
  5550,
  3582,
  3850,
  8480,
  8570,
  8830,
  8978,
  3300,
  3401,
  3210,
  1501,
  1950,
  9771,
  9190,
  9051,
  9700,
  9770,
  4181,
  4342,
  4161,
  4650,
  4257,
  6210,
  7802,
  6200,
  7000,
  7021,
  1033,
  1006,
  1043,
  1060,
  1300,
  2170,
  2630,
  7711,
  6210,
  7190,
  1120,
  1150,
  1320,
  1331,
  1348,
  1404,
  2520,
  2490,
  2530,
  2270,
  5621,
  5640,
  5537,
  5020,
  5377,
  5081,
  3501,
  3620,
  3950,
  8850,
  6821,
  6834,
  6852,
  6853,
  6997,
  1654,
  3118,
  1653,
  9270,
  9290,
  9681,
  4761,
  4140,
  4877,
  4670,
  4750,
  4780,
  4051,
  4652,
  7740,
  6221,
  7942,
  7332,
  7010,
  6500,
  6250,
  7624,
  7611,
  7130,
  6560,
  5560,
  5363,
  5600,
  5641,
  5501,
  5651,
  5030,
  5150,
  3660,
  8610,
  8755,
  6630,
  6660,
  6781,
  6813,
  6920,
  1820,
  1502,
  3370,
  1852,
  1700,
  9860,
  9790,
  9570,
  4458,
  4031,
  4650,
  4560,
  4770,
  6110,
  7034,
  6532,
  6530,
  7604,
  7500,
  7333,
  7803,
  6594,
  7910,
  6120,
  7506,
  7783,
  1200,
  1049,
  1370,
  2590,
  2431,
  2801,
  5523,
  3800,
  3941,
  8554,
  8904,
  8954,
  8956,
  8970,
  6900,
  3200,
  1674,
  3054,
  3010,
  3053,
  1105,
  1050,
  2320,
  2321,
  2531,
  9200,
  9991,
  9180,
  9980,
  9881,
  9571,
  4163,
  4990,
  4450,
  4970,
  4053,
  4681,
  7512,
  7620,
  6142,
  7862,
  7300,
  8370,
  8430,
  8680,
  8740,
  8900,
  6662,
  6672,
  6860,
  6970,
  1831,
  3320,
  5500,
  5022,
  5541,
  5542,
  5520,
  3550,
  3793,
  3803,
  3830,
  3831,
  9500,
  4607,
  4730,
  4050,
  4601,
  4784,
  4920,
  4042,
  7320,
  7830,
  7641,
  1040,
  1342,
  1472,
  2200,
  2900,
  2240,
  2940,
  9570,
  9830,
  9300,
  9340,
  9600,
  9981,
  9850,
  9500,
  9170,
  4624,
  4577,
  4260,
  4821,
  4500,
  4782,
  4671,
  4000,
  4260,
  4672,
  4451,
  4621,
  7823,
  7191,
  6462,
  7623,
  6075,
  6020,
  7601,
  7061,
  1020,
  1090,
  1301,
  1330,
  2610,
  8301,
  8310,
  8421,
  8647,
  8660,
  8800,
  8820,
  8957,
  6686,
  6698,
  6742,
  6836,
  6850,
  6921,
  1931,
  3130,
  3012,
  3271,
  3724,
  3746,
  5024,
  5170,
  5590,
  5333,
  3650,
  3665,
  3720,
  3970,
  8770,
  6640,
  6660,
  6687,
  6717,
  6761,
  6950,
  6990,
  3381,
  3052,
  1673,
  1570,
  3140,
  9032,
  9630,
  9130,
  4540,
  4367,
  4834,
  4602,
  4020,
  4300,
  4608,
  7712,
  6032,
  1081,
  1050,
  2330,
  2500,
  8650,
  8750,
  3294,
  1750,
  9472,
  9680,
  9450,
  9401,
  9820,
  4432,
  4102,
  4160,
  4960,
  4630,
  7784,
  6240,
  6041,
  7750,
  6140,
  7941,
  7350,
  7170,
  7780,
  1041,
  1046,
  1402,
  2323,
  2400,
  5376,
  5530,
  5573,
  5361,
  3600,
  3700,
  3990,
  8000,
  8400,
  8431,
  8572,
  8630,
  8670,
  6671,
  6810,
  6832,
  6952,
  6953,
  1745,
  9320,
  9090,
  9230,
  9880,
  9970,
  9420,
  9260,
  4721,
  4350,
  4100,
  4852,
  4218,
  7511,
  7800,
  7022,
  7533,
  7090,
  7032,
  1082,
  1400,
  2812,
  2910,
  2990,
  5362,
  3631,
  3971,
  8500,
  8710,
  6743,
  6790,
  6811,
  6856,
  6887,
  6972,
  3221,
  3000,
  1980,
  3220,
  1861,
  1760,
  1670,
  1755,
  3460,
  3321,
  9690,
  9750,
  9070,
  9661,
  9240,
  9080,
  4860,
  1031,
  1008,
  1300,
  1420,
  4690,
  4841,
  4130,
  7863,
  6460,
  6511,
  7548,
  7700,
  8490,
  8552,
  8730,
  8851,
  6666,
  6690,
  6730,
  6747,
  6890,
  3440,
  3150,
  3404,
  3290,
  5370,
  5564,
  5555,
  5360,
  5032,
  5380,
  3621,
  3770,
  3790,
  8210,
  8720,
  9099,
  9220,
  9772,
  9992,
  4263,
  4253,
  4850,
  4983,
  4030,
  4837,
  4190,
  4731,
  4950,
  4684,
  4250,
  7540,
  7181,
  7760,
  7530,
  7618,
  7912,
  6000,
  7904,
  7380,
  7070,
  1000,
  1160,
  1340,
  2570,
  2830,
  2450,
  2560,
  2223,
  2800,
  5521,
  5100,
  5332,
  3680,
  3740,
  8940,
  8952,
  6637,
  6674,
  6830,
  6941,
  3390,
  3202,
  1600,
  3060,
  5190,
  5010,
  5101,
  5524,
  3930,
  3945,
  8300,
  8531,
  8790,
  8792,
  6920,
  9521,
  4040,
  4801,
  4280,
  4700,
  4357,
  4980,
  6001,
  7970,
  7972,
  7803,
  6042,
  612,
  1000,
  2275,
  2650,
  2030,
  2950,
  6831,
  6971,
  1804,
  1671,
  1730,
  1702,
  3111,
  1560,
  1601,
  9111,
  9470,
  9950,
  9688,
  9831,
  4633,
  6180,
  7060,
  6030,
  6099,
  6463,
  7742,
  6183,
  7390,
  6220,
  7133,
  1212,
  1210,
  1083,
  1190,
  1357,
  1367,
  1428,
  2540,
  2970,
  2290,
  5353,
  3540,
  3668,
  3890,
  8902,
  8958,
  8980,
  6851,
  6929,
  6986,
  3471,
  3110,
  9255,
  9660,
  9551,
  4000,
  4347,
  4791,
  4219,
  4052,
  3061,
  1547,
  9400,
  9960,
  9400,
  4650,
  4840,
  4537,
  7513,
  7850,
  7971,
  7501,
  7160,
  7643,
  7642,
  7870,
  6543,
  7387,
  1035,
  1348,
  1470,
  2930,
  2920,
  2180,
  2660,
  612,
  5060,
  5560,
  5374,
  3500,
  3511,
  3570,
  3920,
  8450,
  8501,
  8510,
  8551,
  8793,
  8860,
  8950,
  8953,
  6750,
  6762,
  1652,
  1701,
  1620,
  5310,
  5670,
  3792,
  8620,
  8951,
  6670,
  6721,
  6767,
  1934,
  3018,
  3201,
  3360,
  3080,
  3380,
  1651,
  9921,
  9931,
  4170,
  4400,
  4122,
  4121,
  4099,
  4631,
  4890,
  4470,
  7542,
  7331,
  7600,
  6111,
  6040,
  7520,
  1341,
  1350,
  2242,
  2850,
  2491,
  2480,
  8511,
  8780,
  6760,
  3391,
  1980,
  3071,
  5520,
  5070,
  5336,
  3670,
  3732,
  3940,
  3960,
  8340,
  8420,
  8573,
  6706,
  3211,
  1910,
  9120,
  9520,
  9667,
  4452,
  4101,
  4210,
  4802,
  4900,
  6470,
  7801,
  7080,
  7811,
  6031,
  7640,
  7782,
  7743,
  6591,
  7180,
  6182,
  7011,
  7502,
  6590,
  7062,
  6223,
  1110,
  1005,
  1310,
  2980,
  2960,
  2222,
  2580,
  5360,
  5646,
  5503,
  5563,
  5002,
  3832,
  8600,
  8920,
  6720,
  6823,
  6927,
  1500,
  3454,
  1850,
  1970,
  9075,
  9870,
  9040,
  9961,
  9060,
  9990,
  4180,
  4682,
  4317,
  4340,
  4460,
  4720,
  7031,
  7322,
  6043,
  7621,
  6222,
  7866,
  7950,
  1047,
  1099,
  1040,
  2380,
  2020,
  2018,
  1701,
  9310,
  9042,
  9520,
  9552,
  4728,
  4520,
  4987,
  4557,
  7130,
  7503,
  7622,
  7603,
  7041,
  1170,
  1332,
  1435,
  1471,
  1480,
  2300,
  2322,
  2370,
  2243,
  2160,
  5300,
  5544,
  5004,
  3806,
  8530,
  8900,
  8930,
  6680,
  6704,
  6740,
  3400,
  1800,
  1840,
  8377,
  8432,
  8520,
  6838,
  6924,
  1630,
  3040,
  9,
  3000,
  1602,
  3350,
  1932,
  3070,
  5630,
  5561,
  5140,
  5660,
  5031,
  5570,
  3723,
  3840,
  3910,
  8840,
  6700,
  6824,
  9550,
  9100,
  9988,
  9250,
  9150,
  9810,
  9400,
  4590,
  4606,
  4880,
  4831,
  4710,
  4453,
  6060,
  7040,
  6536,
  7804,
  6542,
  6461,
  7531,
  7532,
  1000,
  1390,
  2235,
  3470,
  9404,
  9840,
  9506,
  9160,
  9900,
  4420,
  6150,
  7610,
  7522,
  7370,
  7602,
  6010,
  7321,
  7906,
  7608,
  1315,
  1473,
  2280,
  2040,
  4287,
  4620,
  4217,
  5372,
  5354,
  5021,
  3790,
  3900,
  8433,
  8583,
  8810,
  8870,
  6673,
  6681,
  6690,
  6792,
  6833,
  1770,
  3473,
  3020,
  1981,
  5003,
  5340,
  6661,
  5680,
  5330,
  5562,
  3870,
  8211,
  8890,
  6984,
  4360,
  7880,
  3190,
  9800,
  4780,
  4630,
  4760,
  4171,
  7538,
  6530,
  6280,
  6592,
  1009,
  1048,
  1080,
  2600,
  2340,
  2861,
  2440,
  2070,
  2880,
  2221,
  3078,
  3384,
  3191,
  4120,
  5576,
  5352,
  5570,
  5644,
  5522,
  3510,
  3512,
  8434,
  8560,
  8908,
  8972,
  6782,
  6812,
  6820,
  9932,
  9968,
  9636,
  9041,
  4861,
  4623,
  4711,
  4651,
  4830,
  4431,
  4261,
  4600,
  7140,
  6061,
  7730,
  7521,
  7110,
  6567,
  7334,
  6211,
  1070,
  1325,
  1440,
  1457,
  1470,
  1490,
  2620,
  2860,
  2550,
  2390,
  2470,
  2460,
  2890,
  2000,
  2140,
  6830,
  1830,
  3128,
  1933,
  1703,
  3050,
  1731,
  6769,
  6044,
  6030,
  1780,
  9402,
  9920,
  9185,
  9030,
  9140,
  4141,
  4570,
  6464,
  7861,
  7131,
  7134,
  6181,
  7382,
  7301,
  6230,
  1130,
  1410,
  1474,
  2350,
  2870,
  2360,
  5364,
  5001,
  5000,
  3530,
  3580,
  3742,
  3791,
  3798,
  8460,
  8582,
  8640,
  8690,
  8791,
  8880,
  6600,
  6688,
  6692,
  6980,
  1860,
  1650,
  1742,
  9930,
  5334,
  3545,
  3001,
  9050,
  9890,
  4530,
  4252,
  4783,
  4041,
  4771,
  7033,
  6593,
  6141,
  7973,
  6596,
  7940,
  7781,
  6441,
  7890,
  6238,
  7063,
  6224,
  7030,
  1180,
  1421,
  2230,
  2100,
  5589,
  5620,
  5575,
  5650,
  8540,
  8587,
  8906,
  6663,
  6724,
  1935,
  1851,
  3090,
  5350,
  5330,
  5020,
  3520,
  3721,
  8470,
  8580,
  6780,
  9052,
  9910,
  4162,
  4683,
  4254,
  4650,
  4820,
  4654,
  4430,
  6440,
  7911,
  7024,
  7012,
  6791,
  6960,
  1761,
  7810,
  1044,
  1380,
  2099,
  2220,
  2250,
  2050,
  2288,
  1741,
  1982,
  9620,
  9451,
  9000,
  4550,
  4653,
  4845,
  7340,
  7900,
  7812,
  7050,
  7951,
  1012,
  1007,
  1140,
  1360,
  1430,
  1476,
  1495,
  2430,
  2328,
  2820,
  2260,
  2811,
  2110,
  5504,
  5574,
  3630,
  3730,
  8020,
  8200,
  8380,
  8420,
  8581,
  6741,
  6800,
  6880,
  6922,
  6951,
  6982,
  1733,
  1853,
  1930,
  3051,
  1740,
  3461,
  4701,
  6533,
  7120,
  7534,
  7543,
  7943,
  6540,
  7536,
  7901,
  7903,
  7141,
  1011,
  1030,
  1450,
  1461,
  2840,
  5012,
  5502,
  5572,
  5580,
  3560,
  3690,
  6723,
  6820,
  6940,
  1880,
  1790,
  3293,
  1785,
  9406,
  9971,
  9403,
  9940,
  9982,
  9572,
  9280,
  4610,
  4851,
  4680,
  4790,
  4800,
  4870,
  4800,
  4032,
]

export default postalCodes
